import { Typography } from '@mui/material'
import { Box } from '@mui/system'
import React from 'react'
import ApiParametersTable from './ApiParametersTable'
import ApiEndpointDisplay from './ApiEndpointDisplay'
import ApiResponseExamples from './ApiResponseExamples'
import ApiRequestExamples from './ApiRequestExamples'

const AuthApi = () => {
    const authParameters = [
        { type: 'POST', name: 'username', dataType: 'string', required: true },
        { type: 'POST', name: 'password', dataType: 'string', required: true }
    ];

    return (
        <Box className="flex flex-col border-b border-gray-200">
            <Typography variant="h6" marginBottom={1} fontWeight={600} fontSize={16} id="authentication">AUTHENTICATIONS</Typography>
            
            <Typography variant='body2' marginBottom={2} fontSize={14} fontWeight={600}>
                Authenticate User
            </Typography>
            <Typography variant='body2' marginBottom={2} fontSize={14} fontWeight={400}>
                Authenticate the user with the system and obtain the authorization token.
            </Typography>
            <Typography variant='body2' marginBottom={1} fontSize={14} fontWeight={600}>
                Request
            </Typography>
            <ApiEndpointDisplay 
                method="POST" 
                url="https://backend.novusomnifleet.com/api/client/v1/authenticate" 
            />

            <ApiParametersTable parameters={authParameters} />

            <Typography variant="body2" fontSize={14} fontWeight={400} mb={2}>
                In the request body, send your created username and password.
            </Typography>

            <ApiRequestExamples
                examples={[
                    {
                    type: "body",
                    contentType: "json",
                    value: `{
 "username": "username",
 "password": "password"
}`,
                    label: "Request Body"
                    }
                ]}
            />

            <ApiResponseExamples 
                examples={[
                    {
                        status: '200',
                        description: 'Success',
                        response: `{
                                    "data": {
                                        "token": "eyJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJJQ1NBIiwidXNlcklkIjoiNjdkOTBkMDdlNGNhZTU3MDEwMzQyYzA4Iiwicm9sZXMiOiJST0xFX0ZMRUVUX01BTkFHRVIiLCJpYXQiOjE3NTQzNzIyNjksImV4cCI6MTc1NDQwODI2OX0.NItAkAwXNGKxoAsUTZSwB0lzFPHgW3I4ZwpLEY4c-Lo",
                                        "userId": "67d90d07e4cae5701034c08",
                                        "roles": "ROLE_FLEET_MANAGER"
                                    },
                                    "success": true,
                                    "message": "Authentication successful"
                                    }`
                    },
                    {
                        status: '400',
                        description: 'Missing Fields',
                        response: `{
                                        "success": false,
                                        "message": "Invalid request body",
                                        "errors": [
                                            {
                                            "code": "missing_field",
                                            "field": "username",
                                            "detail": "Username is required"
                                            }
                                        ]
                                        }`
                    },
                    {
                        status: '401',
                        description: 'Invalid Credentials',
                        response: `{
                                        "success": false,
                                        "message": "Invalid username or password"
                                        }`
                    },
                    {
                        status: '500',
                        description: 'Server Error',
                        response: `{
                                        "success": false,
                                        "message": "An internal server error occurred"
                                        }`
                    }
                ]}
            />
        </Box>
    )
}

export default AuthApi